var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisualCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#A9CC13",
    fillOpacity: 0.3,
    stroke: "#A9CC13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 10H11.625C10.1681 10 9 11.1812 9 12.625V25.75H11.625V12.625H24.75V10ZM27.375 15.25H16.875C15.4181 15.25 14.25 16.4313 14.25 17.875V28.375C14.25 29.8188 15.4181 31 16.875 31H27.375C28.8188 31 30 29.8188 30 28.375V17.875C30 16.4313 28.8188 15.25 27.375 15.25Z",
    fill: "#A9CC13"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualCopy);
export default __webpack_public_path__ + "static/media/visual_copy.5edb7d53.svg";
export { ForwardRef as ReactComponent };